module.exports = __webpack_public_path__ + "img/5e9c8147d3553.49c31d19.jpg";